// extracted by mini-css-extract-plugin
export default {"ErrorPlaceholder":"ErrorPlaceholder_ErrorPlaceholder__7rQT8","ErrorMessage":"ErrorPlaceholder_ErrorMessage__2FDfw","ErrorIcon":"ErrorPlaceholder_ErrorIcon__DWVQJ"};